import React from "react";
import { Icon } from "@shopify/polaris";
import { QuestionCircleIcon } from "@shopify/polaris-icons";
import { BundleTypes } from "../apps/Bundles/constants";

export const mantleDocHandles: Record<string, any> = {
    [BundleTypes.BUNDLE_BUILDER]: {
        configureSteps: "ee7d3a93-ebd0-4deb-a39b-c265166eec50",
        setUpDiscounts: "079ba61c-91f9-4b18-8c00-1cc1246bcab7",
        setUpVariantSelector: "9ee5cf6f-9554-464e-b6bd-8ab67722bf1e",
        changeBundleText: "03f1f157-15ff-4c5b-a696-31323ec32d15",
        bundleVisibility: "4d19e598-6812-415b-8483-de9276f77f3f",
        productVisibility: "5720fb6a-f229-4542-b988-da5240a6c80e",
        pricingDisplay: "f207c200-ca39-4e42-ac5b-21285ec7927b",
        productSelectionRules: "292eaae0-13c9-4217-9c17-4717c765a626",
        flowAndConditionalLogic: "9a298ac6-7dd3-4fbb-9d44-96b7fbed5fff",
    },

    [BundleTypes.STANDARD]: {
        setUpStandard: "81d7b61e-b3f5-4ba9-9b7b-42a803d1d013",
    },

    [BundleTypes.VOLUME_DISCOUNT]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.BXGY]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.MIX_MATCH]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.FBT]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.PRODUCT_ADDONS]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.AI_BUNDLES]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.BXGY_SECTIONAL]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.BUNDLE_BUILDER_CTA]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.BB_PLACEHOLDER]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.PRODUCT_ADDONS_POPUP]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.MIX_MATCH_SECTIONAL]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.BUY_N]: {
        setUpDiscounts: "",
        setUpVariantSelector: "",
        changeBundleText: "",
    },

    [BundleTypes.SLIDE_CART]: {},

    [BundleTypes.THANKYOUPAGE]: {},
};

const MantleDoc = ({ handle, title }: { handle: string; title?: string }) => {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();

        window.MantleHelpDeskWidget.openDocsPage({
            handle,
        });
    };

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                {title && <span>{title}</span>}
                {/* {handle && (
                    <div
                        style={{
                            color: "#007bff",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontSize: 11,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontWeight: 400,
                        }}
                        onClick={handleClick}
                    >
                        <span>
                            <Icon source={QuestionCircleIcon} tone="subdued" />
                        </span>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default MantleDoc;
